import { DataCache, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PendingExportsResponse } from 'data/models/PendingExportsResponse';

export class PendingExportsCache extends DataCache {
    PendingExportsResponses = PCCollection(PendingExportsResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.PendingExportsResponses, data.BillingSystems, r => r.BillingSystem, null);
        new QueryResultsRelationship(this.PendingExportsResponses, data.PilotJobOrders, r => r.ExportablePilotJobOrders);
        new QueryResultsRelationship(this.PendingExportsResponses, data.DispatchEvents, r => r.ExportableDispatchEvents);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/pendingexportscache.ts